'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Spinner-module_container__XXSgz{fill:#000;animation:Spinner-module_spin__DmjIz 1s linear infinite;height:auto;vertical-align:baseline;vertical-align:initial;width:1rem}@keyframes Spinner-module_spin__DmjIz{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
var styles = {"container":"Spinner-module_container__XXSgz","spin":"Spinner-module_spin__DmjIz"};
styleInject["default"](css_248z, 'dc1ef82b-5d18-4f0a-b015-ada2c663046c');

exports["default"] = styles;
